import styled from "styled-components";

export const StyledAlert = styled.div`
  padding: var(--spacing-md);
`;

export const StyledAlertIcon = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: var(--spacing-md);
  img {
    width: 144px;
    height: 120px;
    object-fit: contain;
  }
`;

export const StyledAlertContent = styled.div`
  text-align: center;
  h3 {
    font-size: var(--font-size-lg);
    font-weight: 600;
  }
  p {
    font-size: var(--font-size-md);
    padding-bottom: var(--spacing-lg);
  }
  button {
    display: block;
    width: 100%;
  }
`;
